import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
//api
import { getPosts } from 'api/blog';
//custom-hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary'
//components
import NoResults from 'components/userzone/NoResults'
// image
import Pencil from 'assets/img/ico_pencil.png'


const SmallReviews = () => {
  const [smallreviews, setSmallReviews] = useState([])
  const { t } = useTranslation(['childrenBooks'])
  const { assignedLibrary } = useAssignedLibrary()


  const getSmallReviews = async () => {
    const { data, status } = await getPosts({ page: 1, page_size: 10, category: 32 })
    if (status === 200) {
      setSmallReviews(data?.results)
    }
  }

  useEffect(() => {
    getSmallReviews()
  }, [])


  return (
    <Row className="mb-4">
      <Col md={12} className="d-flex subTitleCol p-0 align-items-center">
        <img src={Pencil} alt="pencil.png" />
        <h2 >{t('smallreviews')}</h2>
      </Col>
      <Col md={12} className="d-flex mt-5 container-items-reviews" >
        {
          smallreviews.length > 0 ? smallreviews.slice(-3).map((review) => (
            <Col lg={3} md={3} sm={12} xs={12} key={review.id} className="d-flex flex-column align-items-center justify-content-center container-review mb-5 mb-lg-0">
              <img src={review.featured_image} className="image-small-review" />
              <h3 className="title-item-review text-center">{review.title}</h3>
              <p>{review.featured_paragraph}</p>
              <Link to={`/${assignedLibrary}/blog/${review.publish_date}/${review.slug}`} className="global-link">
                {t('seemore')}
              </Link>
            </Col>
          )) : (
            <NoResults message={t('noResults')} />
          )
        }
      </Col>
      <Col md={12} className="d-flex justify-content-center mt-5">
        <Link to={{
          pathname: `/${assignedLibrary}/blog/32/pequenas-resenas/`,
        }} className=" global-link">
          {t('seemorereviews')}
        </Link>
      </Col>
    </Row>
  )
}

export default SmallReviews
